import React from 'react'
import { Drawer, List, ListItem, ListItemIcon, ListItemText, Divider } from '@material-ui/core'
import {
  PeopleRounded,
  PersonAddRounded,
  DateRangeRounded,
  AttachMoneyRounded,
  DirectionsBusRounded,
  CasinoRounded,
  WebRounded,
  BlockRounded
} from '@material-ui/icons'

import imgs from 'assets/imgs'
import { BOOK, LOGISTIC, PRICES, ROUTES, USERS, PLAYGROUND, WEBSITE_BOOKINGS, BLACKLIST } from 'constants/urls'

export const NavBase = ({
  classes, open, toggleNav, onLinkClick, isDispatcher, isAdmin, isPrexBus, isCarrier
}) => {
  const isMainUser = isDispatcher || isAdmin

  return (
    <Drawer open={open} onClose={toggleNav}>
      <img
        alt='Compass'
        src={imgs.logo}
        className={classes.logo}
      />

      <Divider />

      <List component='nav'>

        <ListItem button onClick={onLinkClick(BOOK)}>
          <ListItemIcon>
            <PersonAddRounded />
          </ListItemIcon>
          <ListItemText primary='Бронювання' />
        </ListItem>

        {isMainUser && (
          <ListItem button onClick={onLinkClick(LOGISTIC)}>
            <ListItemIcon>
              <DateRangeRounded />
            </ListItemIcon>
            <ListItemText primary='Кабінет логіста' />
          </ListItem>
        )}

        {isMainUser && (
          <ListItem button onClick={onLinkClick(PRICES)}>
            <ListItemIcon>
              <AttachMoneyRounded />
            </ListItemIcon>
            <ListItemText primary='Ціни' />
          </ListItem>
        )}

        {isMainUser && (
          <ListItem button onClick={onLinkClick(ROUTES)}>
            <ListItemIcon>
              <DirectionsBusRounded />
            </ListItemIcon>
            <ListItemText primary='Рейси' />
          </ListItem>
        )}

        {isAdmin && (
          <ListItem button onClick={onLinkClick(USERS)}>
            <ListItemIcon>
              <PeopleRounded />
            </ListItemIcon>
            <ListItemText primary='Користувачі' />
          </ListItem>
        )}

        {(isCarrier || isMainUser) && isPrexBus && (
          <ListItem button onClick={onLinkClick(WEBSITE_BOOKINGS)}>
            <ListItemIcon>
              <WebRounded />
            </ListItemIcon>
            <ListItemText primary='Замовлення з сайту' />
          </ListItem>
        )}

        {isMainUser && (
          <ListItem button onClick={onLinkClick(BLACKLIST)}>
            <ListItemIcon>
              <BlockRounded />
            </ListItemIcon>
            <ListItemText primary='Чорний список' />
          </ListItem>
        )}

        {/* {isAdmin && (
          <ListItem button onClick={onLinkClick(PLAYGROUND)}>
            <ListItemIcon>
              <CasinoRounded />
            </ListItemIcon>
            <ListItemText primary='Плейграунд' />
          </ListItem>
        )} */}

      </List>
    </Drawer>
  )
}



// WEBPACK FOOTER //
// ./src/components/Nav/Nav.js